import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList
} from '@angular/core';
import { TotemService } from '../totem.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import Keyboard from 'simple-keyboard';

import { ActivatedRoute } from '@angular/router';
import { Categoria } from '../tiendas/categoria';
import { Subcategoria } from '../tiendas/subcategoria';
import { Tienda } from '../tiendas/tienda';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-zonagourmet',
  templateUrl: './zonagourmet.component.html',
  styleUrls: ['./zonagourmet.component.css']
})
export class ZonagourmetComponent implements OnInit {
  keyboard: Keyboard;
  commonKeyboardOptions = {
    onKeyPress: (button: string) => this.onKeyPress(button)
  };
  tiendas: Array<Tienda>;
  subcategorias: Array<Subcategoria> = [];
  otherTiendasresult: Array<Tienda>;
  contienen: Array<Tienda>;
  contienentags: Array<Tienda>;

  comienzan = true;
  contienentienda = false;
  tienetag = false;

  CategoriasReales = [];
  value: string;
  categoriactual = '';
  teclado = false;
  menu = true;
  claseletra = 'letter-bar show';
  sinletra = false;
  conletra = true;
  inputteclado = '';
  idpatiodecomida = environment.zonaGourmet;
  @ViewChild('inputbusqueda', { static: false }) inputbusqueda: ElementRef;
  nombreant: string;
  todasLasTiendas: Array<Tienda>;
  options = { autoHide: false, scrollbarMinSize: 100 };
  @ViewChildren('listatiendahtml') listatiendahtml: QueryList<ElementRef>;

  listaletras = [];

  constructor(
    private totemService: TotemService,
    private activatedRoute: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}
  async ngOnInit() {
    try {
      const id = Number(this.activatedRoute.snapshot.params.id);
      const tiendas = await this.totemService.getTiendas().toPromise();
      this.tiendas = tiendas.map((tienda: any) => new Tienda(tienda));
      const items = await this.totemService.getCategorias().toPromise();
      const categorias = items.map(item => new Categoria(item));
      for (const categoria of categorias) {
        const subcategorias = categoria.subcategorias.filter(subcategoria =>
          id ? subcategoria.id === id : true
        );
        for (const subcategoria of subcategorias) {
          subcategoria.tiendas = this.tiendas.filter((tienda: Tienda) => {
            return tienda.subcategorias.find(idSubcategoria => {
              return idSubcategoria === subcategoria.id;
            });
          });
          this.subcategorias.push(subcategoria);
        }
      }
      // filtrar tiendas
      let listatiendas = [];
      for (const subca of this.subcategorias) {
        if (subca.id === this.idpatiodecomida) {
          listatiendas = subca.tiendas;
        }
      }
      const listasinlogo = [];
      for (const tienda of listatiendas) {
        if (tienda.estado.toString() === 'Habilitado' ||  tienda.estado.toString() === 'Proximamente') {
          if (tienda.logo || tienda.logo !== '') {
            listasinlogo.push(tienda);
          }
        }
      }
      this.todasLasTiendas = listasinlogo;
      this.otherTiendasresult = listasinlogo;
    } catch (err) {
      console.error(err);
    }
  }

  ngAfterViewInit(): void {
    this.keyboard = new Keyboard({
      ...this.commonKeyboardOptions,
      layout: {
        default: [
          '1 2 3 4 5 6 7 8 9 0 {bksp}',
          'q w e r t y u i o p',
          'a s d f g h j k l ñ',
          'z x c v b n m & ` {Cancelar}',
          '{space}'
        ]
      },
      display: {
        '{Cancelar}': ' Cancelar ',
        '{bksp}': ' ⌫',
        '{space}': '<i class="material-icons"></i>'
      },
      useButtonTag: true,
      onChange: input => this.onChange(input)
    });
  }
  public desplegarteclado() {
    this.value = '';
    this.keyboard.setInput('');
    this.filterTiendas('');
    this.teclado = !this.teclado;
    this.menu = !this.menu;
  }
  public onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value);
  }
  onKeyPress = (button: string) => {
    if (button === '{Cancelar}') {
      setTimeout(() => {
        this.desplegarteclado();
      }, 100);
    }
  }
  private onChange(input: string) {
    this.cancelartimer();
    if (this.teclado === true) {
      this.value = input;
      this.filterTiendas(input);
    }
  }
  private filterTiendas(input: string) {
    input = input.toUpperCase();
    if (!input || input === '') {
      this.comienzan = true;
      this.contienentienda = false;
      this.tienetag = false;
      this.contienen = [];
      this.contienentags = [];
      return (this.otherTiendasresult = this.todasLasTiendas);
    }
    let tiendasfiltrar = this.todasLasTiendas.slice();

    // filtrar si empiezan
    this.otherTiendasresult = tiendasfiltrar.filter((tienda: Tienda) => {
      const nombretienda = this.eliminarDiacriticos(tienda.nombre);
      return nombretienda.toUpperCase().indexOf(input) === 0;
    });
    if (this.otherTiendasresult.length > 0) {
      this.comienzan = true;
    } else {
      this.comienzan = false;
    }
    tiendasfiltrar = this.eliminartienda(tiendasfiltrar, this.otherTiendasresult);
    // filtrar si contienen
    this.contienen = tiendasfiltrar.filter((tienda: Tienda) => {
      const nombretienda = this.eliminarDiacriticos(tienda.nombre);
      return nombretienda.toUpperCase().includes(input) === true;
    });
    if (this.contienen.length > 0) {
      this.contienentienda = true;
    } else {
      this.contienentienda = false;
    }
    tiendasfiltrar = this.eliminartienda(tiendasfiltrar, this.contienen);
    // filtrar por tags
    if (input.length > 1) {
      this.contienentags = tiendasfiltrar.filter((tienda: Tienda) => {
        const mastiendas = tienda.tags.filter((tagstiendas) => {
          const tag = this.eliminarDiacriticos(tagstiendas);
          return tag.toUpperCase().includes(input) === true;
        });
        if (mastiendas.length !== 0) {
          const sindidactricos = [];
          for (const tagsin of mastiendas) {
            sindidactricos.push(this.eliminarDiacriticos(tagsin));
          }
          tienda.tags = sindidactricos;
          return tienda;
        }
      });
    }
    if (this.contienentags.length > 0) {
      this.tienetag = true;
    } else {
      this.tienetag = false;
    }
  }
  eliminarDiacriticos(texto) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  eliminartienda(tiendasporfiltrar: any, tiendasfiltradas: any) {
    for (const tienda of tiendasfiltradas ) {
      if (tiendasporfiltrar.indexOf(tienda)) {
        const ubicacion = tiendasporfiltrar.indexOf(tienda);
        tiendasporfiltrar.splice( ubicacion, 1 );
      }
    }
    return tiendasporfiltrar;
  }


  public presionartecla(letra) {
    const listatiendas = [];
    for (const tienda of this.tiendas) {
      const primera = tienda.nombre[0];
      if (primera === letra) {
        listatiendas.push(tienda);
      }
    }
    this.otherTiendasresult = listatiendas;
    console.log('lettra', letra);
  }

  public enviarEventoFiltro(categoria) {
    this.googleAnalyticsService.eventEmitter(
      'tiendas',
      'filter',
      'categoria',
      categoria
    );
  }
  // logica de reinicio
  scrollevent = (event: any): void => {
    this.cancelartimer();
  }
  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }
}
